import { Component, forwardRef, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CustomerClient, CustomerDto } from '../../api-connector/sso-connector';
import { BaseAutocompleteControl } from '../base-autocomplete-control';
import { AutocompleteCacheService } from '../../services/autocomplete-cache.service';

@Component({
  selector: 'app-customer-search-control',
  templateUrl: './customer-search-control.component.html',
  styleUrls: ['./customer-search-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomerSearchControlComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CustomerSearchControlComponent),
      multi: true,
    }
  ]
})
export class CustomerSearchControlComponent extends BaseAutocompleteControl<CustomerDto> implements OnInit {

  constructor(
    private customerClient: CustomerClient,
    private cache: AutocompleteCacheService
  ) {
    super();
  }

  ngOnInit(): void {
    if (!this.placeholder || this.placeholder === '---Lựa chọn---') {
      this.placeholder = 'Tìm tên, mã hoặc SĐT...';
    }
    super.ngOnInit();
  }

  /**
   * Fetch customers from API
   */
  protected fetchItems(searchValue: string): Observable<CustomerDto[]> {
    const cacheKey = `customer_search_${searchValue}`;
    return this.cache.wrap(cacheKey, this.customerClient.getCustomerByKeySearch(searchValue).pipe(
      map(items => items || [])
    ));
  }

  /**
   * Get display value for customer
   */
  getDisplayValue(item: CustomerDto | any | null): string {
    if (typeof item === 'string') return item;
    return item?.name || item?.Name || '';
  }

  /**
   * Check if value is a valid CustomerDto instance
   */
  protected isValidItem(value: any): boolean {
    return value && (value instanceof CustomerDto || value.id !== undefined || value.Id !== undefined);
  }

  /**
   * Optional: Return full customer object for display
   */
  displayCustomer = (customer?: CustomerDto) => {
    return customer ? customer : {};
  }
}
